module.exports = __webpack_public_path__ + "static/media/agenda.02df96ef.png";